import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import LandingVideoModal from "./LandingVideoModal";
import useLandingVideoModal from "./useLandingVideoModal";

const LandingVideoContext = createContext(null);

export const LandingVideoProvider = ({ children }) => {
  const [video, setVideo] = useState(null);

  const {
    isOpen,
    embed,
    playerRef,
    modalRef,
    openModal,
    closeModal,
    seekTo,
  } = useLandingVideoModal(video?.videoUrl);

  const registerVideo = useCallback((nextVideo) => {
    if (!nextVideo?.videoUrl) return;
    setVideo(nextVideo);
  }, []);

  const openVideoModal = useCallback(
    (url, start = 0) => {
      openModal(start, url || undefined);
    },
    [openModal]
  );

  const value = useMemo(
    () => ({
      video,
      registerVideo,
      openVideoModal,
      closeVideoModal: closeModal,
      seekTo,
    }),
    [video, registerVideo, openVideoModal, closeModal, seekTo]
  );

  return (
    <LandingVideoContext.Provider value={value}>
      {children}
      <LandingVideoModal
        isOpen={isOpen}
        embed={embed}
        playerRef={playerRef}
        modalRef={modalRef}
        videoTitle={video?.videoTitle}
        chapters={video?.chapters}
        onClose={closeModal}
        onSeek={seekTo}
      />
    </LandingVideoContext.Provider>
  );
};

export const useLandingVideoContext = () => useContext(LandingVideoContext);
